/* eslint-disable */
import * as Types from './types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type GetFooterQueryVariables = Types.Exact<{
  locale: Types.Scalars['String'];
}>;


export type GetFooterQuery = { __typename?: 'Query', navigationFooterMenuCollection?: { __typename?: 'NavigationFooterMenuCollection', items: Array<{ __typename?: 'NavigationFooterMenu', footerNavigationItemCollection?: { __typename?: 'NavigationFooterMenuFooterNavigationItemCollection', items: Array<{ __typename?: 'NavigationItem', nestedNavigationItemCollection?: { __typename?: 'NavigationItemNestedNavigationItemCollection', items: Array<{ __typename?: 'NavigationItem', text?: string | null, url?: string | null, openLinkInNewTab?: boolean | null, nestedNavigationItemCollection?: { __typename?: 'NavigationItemNestedNavigationItemCollection', items: Array<{ __typename?: 'NavigationItem', text?: string | null, url?: string | null, openLinkInNewTab?: boolean | null } | null> } | null } | null> } | null } | null> } | null } | null> } | null };

export declare const getFooter: import("graphql").DocumentNode;

export const GetFooterDocument = /*#__PURE__*/ `
    query getFooter($locale: String!) {
  navigationFooterMenuCollection(
    limit: 1
    locale: $locale
    where: {handle: "footer"}
  ) {
    items {
      footerNavigationItemCollection(where: {sys: {id_exists: true}}) {
        items {
          nestedNavigationItemCollection(limit: 4) {
            items {
              text
              url
              openLinkInNewTab
              nestedNavigationItemCollection(limit: 10) {
                items {
                  text
                  url
                  openLinkInNewTab
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const useGetFooterQuery = <
      TData = GetFooterQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: GetFooterQueryVariables,
      options?: UseQueryOptions<GetFooterQuery, TError, TData>
    ) =>
    useQuery<GetFooterQuery, TError, TData>(
      ['getFooter', variables],
      fetcher<GetFooterQuery, GetFooterQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetFooterDocument, variables, options),
      options
    );

useGetFooterQuery.getKey = (variables: GetFooterQueryVariables) => ['getFooter', variables];
;

useGetFooterQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: GetFooterQueryVariables, options?: RequestInit['headers']) => fetcher<GetFooterQuery, GetFooterQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, GetFooterDocument, variables, options);